import { createReducer } from '@reduxjs/toolkit';

import getRoles from '../../thunks/roles/getRoles';

const initialState = {
  loading: false,
  error: null,
  roles: undefined
};

const getRolesReducer = createReducer(initialState, {
  [getRoles.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getRoles.fulfilled]: (state, { payload: roles }) => ({
    ...state,
    loading: false,
    roles
  }),
  [getRoles.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    roles: undefined
  }),
});

export default getRolesReducer;
